// extracted by mini-css-extract-plugin
export default {"zoomControls":"Raa-z","zoomControlButton":"Saa-z","zoomBanner":"Taa-z","bannerButton":"Uaa-z","imageButton":"Vaa-z","zoom":"Waa-z","zoomContent":"Xaa-z"};